<template>
  <a :href="currencyUrl" class="other-crypto__row">
    <span class="other-crypto__cell" v-once>
      <CryptoIcon :icon-name="code.toLowerCase()" mob-plain />
    </span>

    <span class="other-crypto__cell" v-once>
      <span class="ml-16 mr-16">{{ title }}</span>
      <span class="text-grey ml-16 mr-16">{{ code }}</span>
    </span>

    <span class="other-crypto__cell is-right" style="margin-left: auto">
      <transition name="fade">
        <span :key="fullPrice" class="text-bold">
          {{ fullPrice }}
        </span>
      </transition>
      <transition name="fade">
        <span :key="change" :class="[isPositiveChange ? 'text-green': 'text-red']">
          {{ formattedChange }}
        </span>
      </transition>
    </span>
  </a>
</template>

<script>
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';
import { mapState } from 'vuex';

import CryptoIcon from '@/components/Prices/CryptoIcon.vue';
import getFullPrice from '@/helpers/fullPrice';

export default {
  name: 'OtherCryptoRow',

  props: {
    title: { type: String, required: false, default: null },
    code: { type: String, required: false, default: null },
    slug: { type: String, required: false, default: null },
    price: { type: [String, Number], required: false, default: null },
    change: { type: [String, Number], required: false, default: null },
  },

  components: {
    CryptoIcon,
  },

  computed: {
    ...mapState(['language']),
    ...mapState('cryptoCurrency', ['selectedFiatCurrency', 'isPublicPage']),

    currencyUrl () {
      const urlPrefix = this.isPublicPage ? '' : '/member';

      return UrlGenerator.generate(`${urlPrefix}/price/${this.slug}/`);
    },

    fullPrice () {
      return getFullPrice(this.language, this.selectedFiatCurrency.code, this.price);
    },

    isPositiveChange () {
      return this.change > 0;
    },

    formattedChange () {
      const change = Number(this.change).toFixed(2) + '%';

      return this.isPositiveChange ? '+' + change : change;
    },
  },
};
</script>

<style scoped lang="scss">
@use 'scss-vars';

.other-crypto {
  width: 100%;
  max-width: 768px;
  padding: 0 16px;
  margin: 54px auto 0 auto;

  &__row {
    display: flex;
    padding: 14px 0;
    border-bottom: 1px solid scss-vars.$black-06;

    &:last-child {
      margin-bottom: 54px;
    }
  }

  &__cell {
    display: flex;
    flex-direction: column;

    span {
      cursor: pointer;
    }
  }

  &__cell.is-right {
    text-align: right;
  }

  [dir='rtl'] &__cell.is-right {
    text-align: left;
  }
}
// @TODO code was moved to global css. Check how it will be fork without local styles.
.fade-enter-active{
  transition: opacity 1s;
}
.fade-enter,
.fade-enter-from {
  opacity: .2;
}
.fade-leave-active {
  display: none;
}
</style>
